export Switch from './Switch'
export SwitchLabel from './SwitchLabel'

export default from './Switch'



// WEBPACK FOOTER //
// ./src/Switch/index.js